import { Fragment } from "react";
import { useApi } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Loading } from "../components/Common";
import RecentlyViewed from "../components/RecentlyViewed";
import HeroSlider from "../components/HeroSlider";
import { Recommended } from "../components/Recommendations";
import Seo from "../components/Seo";
import { About } from "../components/home/About";
import { Spotlight } from "../components/home/Spotlight";
import { Featured } from "../components/home/Featured";
import { Glance } from "../components/home/Glance";
import { Cities, TypeGrid } from "../components/home/Browse";
import { HowItWorks, Services, Why } from "../components/home/Pillars";
import { CtaBand } from "../components/home/CtaBand";
import { NewsRow, Social, Stats, Tabs, Upcoming } from "../components/home/Legacy";

const SECTIONS = {
  about: (d) => <About about={d.about} />,
  spotlight: (d) => <Spotlight spot={d.spotlight} />,
  featured: (d) => <Featured projects={d.featured_projects} />,
  glance: (d) => <Glance g={d.glance} />,
  stats: (d) => <Stats stats={d.stats} />,
  tabs: (d) => <Tabs tabs={d.tabs} />,
  types: (d) => <TypeGrid counts={d.type_counts} />,
  cities: (d) => <Cities cards={d.city_cards} map={d.city_map} />,
  upcoming: (d) => <Upcoming projects={d.upcoming_projects} investment={d.investment_properties} />,
  services: () => <Services />,
  why: () => <Why />,
  recommendations: (d) => <><Recommended fallback={d.popular} /><RecentlyViewed /></>,
  how: () => <HowItWorks />,
  news: (d) => <NewsRow articles={d.articles} />,
  social: (d) => <Social testimonials={d.testimonials} partners={d.partners} />,
  cta: (d) => <CtaBand image={d.spotlight?.project?.gallery?.[1] || d.spotlight?.project?.cover_image} />,
};

export default function Home() {
  const { tr } = useI18n();
  const { data, loading } = useApi("/home");
  if (loading || !data) return <Loading />;
  return (
    <div data-testid="home-page">
      <Seo title={tr(data.banner, "title")} description={tr(data.banner, "subtitle")} image={data.banner?.image_url} />
      {data.slides?.length > 0 && <HeroSlider slides={data.slides} />}
      {data.sections.filter((s) => s.visible && SECTIONS[s.key]).map((s) => (<Fragment key={s.key}>{SECTIONS[s.key](data)}</Fragment>))}
    </div>
  );
}
